( function($) {

	var FiltersToggle = function() {
		this.toggle = $( talentfunl_filters_toggle.toggle_selector );

		if ( this.toggle.length ) {
			this.init();
		}
	};

	FiltersToggle.prototype = $.extend( FiltersToggle.prototype, {
		init: function() {
			this.filters = $( talentfunl_filters_toggle.filters_selector );

			this.toggleLastState = null;
			this.handleResize();

			this.toggle.on( 'click', $.proxy( this.toggleFilters, this ) );
			$( window ).resize( $.proxy( this.handleResize, this ) );
		},

		toggleFilters: function( e ) {
			e.preventDefault();

			if ( this.toggle.hasClass( 'expanded' ) && this.filters.is( ':visible' ) ) {
				this.toggle.removeClass( 'expanded' );
				this.filters.slideUp();
			} else {
				this.toggle.addClass( 'expanded' );
				this.filters.slideDown();
			}
		},

		handleResize: function() {
			var isVisible = this.toggle.is( ':visible' );

			if ( isVisible !== this.toggleLastState ) {
				if ( isVisible ) {
					this.filters.hide();
				} else {
					this.filters.show();
				}

				this.toggleLastState = isVisible;
			}
		}
	} );

	$( document ).ready( function() {

		new FiltersToggle();

	} );

} )( jQuery );
